module.exports = "<p>\r\n  articulo-subcategoria works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/components/articulo-subcategoria/articulo-subcategoria.component.html
// module id = ../../../../../src/app/components/articulo-subcategoria/articulo-subcategoria.component.html
// module chunks = main